(() => {
    const dropdowns = document.querySelectorAll('.dropdown');
    dropdowns.forEach( dropdown => {
        const select = dropdown.querySelector('.select');
        const caret = dropdown.querySelector('.caret');
        const menu = dropdown.querySelector('.menu');
        const options = dropdown.querySelector('.menu-item');
        const selected = dropdown.querySelector('.selected');

        select.addEventListener('click', () => {
            select.classList.toggle('selected-clicked');
            caret.classList.toggle('caret-rotate');
            menu.classList.toggle('menu-open');
        });
    });

    function hiddeDropdown() {
        for(let i = 0; i < dropdowns.length; i++) {
            let menu = dropdowns[i].querySelector('.menu');
            if(menu.classList.contains('menu-open')) menu.classList.remove('menu-open');
        }
    }
})()